import { render, staticRenderFns } from "./POIHutsState.vue?vue&type=template&id=34d2bdbd"
import script from "./POIHutsState.js?vue&type=script&lang=js&external"
export * from "./POIHutsState.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports